import { GrowthBook } from '@growthbook/growthbook-react'
import { useMemo } from 'react'

interface WindowWithGB extends Window {
  gb: GrowthBook
}

export default () => {
  const gb: GrowthBook = useMemo(() => (window as unknown as WindowWithGB)?.gb, [])

  return gb
}
